if(process.env.NODE_ENV === 'test') {
  const UiFramework = require('@eureka/ui-components/commonjs2/static/js/ui-components.js')
  const { eureka } = UiFramework.default || UiFramework;
  module.exports = eureka.default || eureka;
} else {
  const eureka = require('@eureka/ui-components/index.esm');
  module.exports = eureka;
}